import { baseBUCGet } from '../base/baseBUC';

const str = '';
const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const collectionCashModelGet = ({
    buildingId = '',
    coinId = '',
    userId = '',
}) => {
    return {
        //buildingId: buildingId,
        coinId: coinId,
        //userId: userId,
        //created: dateTimeStr,
        date: dateTimeStr,
        description: str,
        currentBalance: decimal,
        currentBalanceCash: decimal,
        initialBalance: decimal,
        initialBalanceCash: decimal,
        inactive: false,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};